import { useTranslation } from 'react-i18next';

import { rootStyle } from './DiscountProgress.css';
import { DiscountProgressItem } from './DiscountProgressItem';

export type DiscountStep = {
  hint?: string;
  isActive: boolean;
  label: string;
};

type Props = {
  items: DiscountStep[];
};

export const DiscountProgress = ({ items }: Props) => {
  const lastActiveIndex = items.findLastIndex((item) => item.isActive);

  const { t } = useTranslation(['invitations']);

  return (
    <ol aria-label={t('invitations:discount.ariaLabel', { completed: lastActiveIndex + 1, total: items.length })} className={rootStyle}>
      {items.map((item, index) => (
        <DiscountProgressItem isLastActiveItem={index === lastActiveIndex} item={item} key={index} />
      ))}
    </ol>
  );
};
